/** Shared */
import faviconBadge from './shared/favicon-badge.js';

/** Theme */
import { buildAttorneySidebar, stickyAttorneySidebar, highlightAttorneySidebar } from './theme/attorney-single-sidebar';
import fancybox from './theme/fancybox.js';
import menuFocusAria from './theme/menu-focus-aria';
import scrollTransition from './theme/scroll-transition';
import selectChangeWindowLocation from './theme/select-change-window-location';
import alerts      from './theme/alerts.js';

/** Theme Atoms */
// import aMaxWidthIFrame from './theme/a-max-width-iframe';
import aMinWidthTable from './theme/a-min-width-table';

/** Theme Molecules */

/** Theme Organisms */

document.addEventListener('DOMContentLoaded', function() {

  /** Address HTML & Body no-js Class */
  (function () {

    /** Remove */
    // document.documentElement.classList.remove('no-js');
    // document.body.classList.remove('no-js');

    /** Replace */
    document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
    document.body.className = document.body.className.replace('no-js', 'js');
  })();

  /** Config */
  faviconBadge();

  /** Theme */
  fancybox();
  menuFocusAria();

  /** Theme Atoms */
  // aMaxWidthIFrame();
  aMinWidthTable();

  /** Theme Molecules */

  /** Theme Organisms */
  buildAttorneySidebar();
  stickyAttorneySidebar();

  scrollTransition();
  selectChangeWindowLocation();

  alerts();

});
